const SVGComponent = ({ isActive, props }) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.3748 5.62508V3.95841C14.3748 3.03794 13.6286 2.29175 12.7082 2.29175H3.95817C3.0377 2.29175 2.2915 3.03794 2.2915 3.95841V12.7084C2.2915 13.6289 3.0377 14.3751 3.95817 14.3751H5.62484M7.77172 17.7084C8.15578 15.8036 9.75366 14.3751 11.6665 14.3751C13.5794 14.3751 15.1772 15.8036 15.5613 17.7084M7.77172 17.7084H7.2915C6.37103 17.7084 5.62484 16.9622 5.62484 16.0417V7.29175C5.62484 6.37127 6.37103 5.62508 7.2915 5.62508H16.0415C16.962 5.62508 17.7082 6.37127 17.7082 7.29175V16.0417C17.7082 16.9622 16.962 17.7084 16.0415 17.7084H15.5613M7.77172 17.7084H15.5613M13.5415 10.4167C13.5415 11.4523 12.702 12.2917 11.6665 12.2917C10.631 12.2917 9.7915 11.4523 9.7915 10.4167C9.7915 9.38121 10.631 8.54175 11.6665 8.54175C12.702 8.54175 13.5415 9.38121 13.5415 10.4167Z"
      stroke={isActive ? "#225AEA" : "currentColor"}
      strokeWidth={1.5}
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)
export default SVGComponent
